import styled from "@emotion/styled";
import * as React from "react";
import { Section } from "../layout/section";
import { HorizontalCard } from "../ui/cards/horizontal";
import { StaticImage } from "gatsby-plugin-image";

const StyledPrograms = styled.div`
  background-color: var(--off-white);

  header {
    text-align: center;
    max-width: 1220px;
    margin: auto;

    p {
      margin-top: var(--mini);
    }
  }

  .cards {
    margin-top: var(--x-small);
  }
`;

export const Programs = () => (
  <StyledPrograms>
    <Section>
      <div className="row">
        <header>
          <h2 className="h2">White Label SEO Programs & Offerings</h2>
          <p>
            Agency Elevation offers a variety of white label SEO reseller
            packages. The most common packages are for white label local SEO,
            white label national SEO, and white label eCommerce SEO services. We
            also offer white label link building services as a standalone option
            if you only need additional link building and signal-generating
            methods for your clients without the other optimizations or aspects
            of an SEO campaign.
          </p>
        </header>

        <div className="cards">
          <HorizontalCard
            title="White Label Local SEO Services"
            text="Our standard white label local SEO package includes all aspects of local SEO that are necessary to see ranking improvements and produce results for your clients. Unique to the local SEO landscape, we focus heavily on GBP optimizations, custom-written GBP Posts that are heavily optimized around our keyword research findings, generating local-based signals for optimal local SEO rankings, tracking geogrid (heatmap) rankings, and deeply monitoring your clients’ GBP listings for new reviews, new engagement opportunities, and many other factors that result in successful white label local SEO campaigns."
            link={{
              url: "/contact/",
              text: "Get Started",
            }}
          >
            <StaticImage
              src="../../images/seo/local.png"
              alt="White Label Local SEO Services"
              imgClassName="img"
              class="img-container-wide"
              placeholder="none"
            />
          </HorizontalCard>

          <HorizontalCard
            title="White Label National SEO Services"
            text="Our national white label SEO package includes all aspects needed to see ranking improvements to get your clients on page one of Google in more competitive markets. It starts with SEO audits, keyword research, content creation, on-page optimizations, off-page optimizations, link building, signal generation, reporting, and a stronger emphasis on higher-authority backlinks to move the needle to compete on more competitive landscapes in regards to Domain Authority and Domain Rating."
            link={{
              url: "/contact/",
              text: "Get Started",
            }}
          >
            <StaticImage
              src="../../images/seo/national.png"
              alt="White Label National SEO Services"
              imgClassName="img"
              class="img-container-wide"
              placeholder="none"
            />
          </HorizontalCard>

          <HorizontalCard
            title="White Label eCommerce SEO Services"
            text="Similar to our national package, with the main difference being we do a lot of competitive research on product terms, category keywords, and focusing on optimizing product descriptions to the best of our ability (some eCommerce platforms limit what we can do). White label eCommerce SEO campaigns also require extensive link building and Domain Authority improvements, which are included in our package."
            link={{
              url: "/contact/",
              text: "Get Started",
            }}
          >
            <StaticImage
              src="../../images/seo/local.png"
              alt="White Label eCommerce SEO Services"
              imgClassName="img"
              class="img-container-wide"
              placeholder="none"
            />
          </HorizontalCard>
        </div>
      </div>
    </Section>
  </StyledPrograms>
);
